
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/jobs/[slug]",
      function () {
        return require("private-next-pages/companies/jobs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/jobs/[slug]"])
      });
    }
  